/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const BooleanFieldValueTypename =
  'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export type BooleanFieldValue = {
  value: boolean;
  __typename: 'com.hubspot.chirp.ext.models.BooleanFieldValue';
} & { '@type'?: 'boolean' };

export const DoubleFieldValueTypename =
  'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export type DoubleFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.DoubleFieldValue';
} & { '@type'?: 'double' };

export const FieldValueDiscriminantKey = '@type';
export type FieldValue =
  | NullFieldValue
  | BooleanFieldValue
  | DoubleFieldValue
  | FloatFieldValue
  | IntFieldValue
  | LongFieldValue
  | StringFieldValue
  | ListFieldValue
  | MapFieldValue;

export const FloatFieldValueTypename =
  'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export type FloatFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.FloatFieldValue';
} & { '@type'?: 'float' };

export const IntFieldValueTypename =
  'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export type IntFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.IntFieldValue';
} & { '@type'?: 'integer' };

export const ListFieldValueTypename =
  'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export type ListFieldValue = {
  value: Default<FieldValue[]>;
  __typename: 'com.hubspot.chirp.ext.models.ListFieldValue';
} & { '@type'?: 'list' };

export const LongFieldValueTypename =
  'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export type LongFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.LongFieldValue';
} & { '@type'?: 'long' };

export const MapFieldValueTypename =
  'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export type MapFieldValue = {
  value: Default<Record<string, FieldValue>>;
  __typename: 'com.hubspot.chirp.ext.models.MapFieldValue';
} & { '@type'?: 'map' };

export const NullFieldValueTypename =
  'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export type NullFieldValue = {
  __typename: 'com.hubspot.chirp.ext.models.NullFieldValue';
} & { '@type'?: 'null' };

export const StringFieldValueTypename =
  'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export type StringFieldValue = {
  value: string;
  __typename: 'com.hubspot.chirp.ext.models.StringFieldValue';
} & { '@type'?: 'string' };

export type AppReleaseEntry = {
  releaseTag: string;
  releaseNotes?: string;
  createdAt: number;
};

export type GetAppFeaturesBatchRequest = {
  appIds: Default<number[]>;
  language?: string;
};

export type GetAppFeaturesBatchResponse = {
  featuresByAppId: Default<Record<string, FieldValue>>;
};

export type GetAppReleaseHistoryRequest = { slug: string };

export type GetAppReleaseHistoryResponse = {
  releases: Default<AppReleaseEntry[]>;
};

export type ListingDetailsError = {
  message: string;
  type: ListingDetailsErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ListingDetailsRequestV2 = { slug: string; language?: string };

export type ListingDetailsResponseV2 = { listing: FieldValue };

export type ListingSupplementBatchRequest = {
  productType: ProductType;
  sourceIds: Default<string[]>;
};

export type ListingSupplementBatchResponse = {
  supplementsBySourceId: Default<Record<string, ListingSupplementResponse>>;
};

export type ListingSupplementRequest = {
  productType: ProductType;
  sourceId: string;
};

export type ListingSupplementResponse = {
  sourceId: string;
  listingId: number;
  productType: ProductType;
  name: string;
  inAppListingDetailsUrl?: string;
};

export type StandardizedInstallRequest = { listingId: number };

export type StandardizedInstallResponse = { standardizedInstall: boolean };

export type ListingDetailsErrorType =
  | 'LISTING_NOT_FOUND'
  | 'UNAUTHORIZED_BETA_SLUG_ACCESS'
  | 'INVALID_INPUT'
  | 'MISSING_SCHEMA_ID'
  | unhandledEnumCase;

export type ListingDetailsRequestV3 = {
  slug?: string;
  listingId?: number;
  language?: string;
};

export type ListingDetailsResponseV3 = {
  listing: FieldValue;
  listingLanguage?: string;
};

export type ProductType =
  | 'APP'
  | 'THEME'
  | 'MODULE'
  | 'AGENT'
  | 'SOLUTIONS_PARTNER_PROFILE'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type GetListingDetailsV2RequestType =
  Requestify<ListingDetailsRequestV2>;
export type GetListingDetailsV2ResponseType = ListingDetailsResponseV2;
export type GetListingDetailsV2ErrorType = ListingDetailsError &
  HubspotMetadata;
export const getListingDetailsV2Rpc: ChirpAvroRpcDetails<
  GetListingDetailsV2RequestType,
  GetListingDetailsV2ResponseType,
  GetListingDetailsV2ErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV2',
  auth: 'external',
  fingerprint: 'XXty8CSBgCBFlkikHog9NUa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingDetailsV3RequestType =
  Requestify<ListingDetailsRequestV3>;
export type GetListingDetailsV3ResponseType = ListingDetailsResponseV3;
export type GetListingDetailsV3ErrorType = ListingDetailsError &
  HubspotMetadata;
export const getListingDetailsV3Rpc: ChirpAvroRpcDetails<
  GetListingDetailsV3RequestType,
  GetListingDetailsV3ResponseType,
  GetListingDetailsV3ErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV3',
  auth: 'external',
  fingerprint: 'xC4cfuFcTIajfkJwW1qLGka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type IsStandardizedInstallRequestType =
  Requestify<StandardizedInstallRequest>;
export type IsStandardizedInstallResponseType = StandardizedInstallResponse;
export type IsStandardizedInstallErrorType = ListingDetailsError &
  HubspotMetadata;
export const isStandardizedInstallRpc: ChirpAvroRpcDetails<
  IsStandardizedInstallRequestType,
  IsStandardizedInstallResponseType,
  IsStandardizedInstallErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'isStandardizedInstall',
  auth: 'external',
  fingerprint: 'krkkLOPAQwLlbiVV77nC_ka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppFeaturesBatchRequestType =
  Requestify<GetAppFeaturesBatchRequest>;
export type GetAppFeaturesBatchResponseType = GetAppFeaturesBatchResponse;
export type GetAppFeaturesBatchErrorType = ListingDetailsError &
  HubspotMetadata;
export const getAppFeaturesBatchRpc: ChirpAvroRpcDetails<
  GetAppFeaturesBatchRequestType,
  GetAppFeaturesBatchResponseType,
  GetAppFeaturesBatchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getAppFeaturesBatch',
  auth: 'external',
  fingerprint: '2yBOkO4gbQD5Dpfy5czg3ka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingSupplementRequestType =
  Requestify<ListingSupplementRequest>;
export type GetListingSupplementResponseType = ListingSupplementResponse;
export type GetListingSupplementErrorType = ListingDetailsError &
  HubspotMetadata;
export const getListingSupplementRpc: ChirpAvroRpcDetails<
  GetListingSupplementRequestType,
  GetListingSupplementResponseType,
  GetListingSupplementErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingSupplement',
  auth: 'external',
  fingerprint: 'PkRsGcD7s8SwWM4tij5JEEa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingSupplementBatchRequestType =
  Requestify<ListingSupplementBatchRequest>;
export type GetListingSupplementBatchResponseType =
  ListingSupplementBatchResponse;
export type GetListingSupplementBatchErrorType = ListingDetailsError &
  HubspotMetadata;
export const getListingSupplementBatchRpc: ChirpAvroRpcDetails<
  GetListingSupplementBatchRequestType,
  GetListingSupplementBatchResponseType,
  GetListingSupplementBatchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingSupplementBatch',
  auth: 'external',
  fingerprint: 'GloNGdlDisWhljQejCy8yka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppReleaseHistoryRequestType =
  Requestify<GetAppReleaseHistoryRequest>;
export type GetAppReleaseHistoryResponseType = GetAppReleaseHistoryResponse;
export type GetAppReleaseHistoryErrorType = ListingDetailsError &
  HubspotMetadata;
export const getAppReleaseHistoryRpc: ChirpAvroRpcDetails<
  GetAppReleaseHistoryRequestType,
  GetAppReleaseHistoryResponseType,
  GetAppReleaseHistoryErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getAppReleaseHistory',
  auth: 'external',
  fingerprint: '7Hd9033N9P75AD2FamQgkka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
